import axiosInstance from "./axiosConfig";

class WorkspaceServices {

  // Delete a workspace by ID
  static async deleteWorkspace(workspaceId) {
    try {
      const response = await axiosInstance.delete(process.env.REACT_APP_API_URL+`/workspace/${workspaceId}`);
      return response;
    } catch (error) {
      console.error('Error deleting workspace:', error);
      throw error;
    }
  }

  // Read a workspace by ID
  static async getWorkspace(workspaceId) {
    try {
      const response = await axiosInstance.get(process.env.REACT_APP_API_URL+`/workspace/${workspaceId}`);
      return response;
    } catch (error) {
      console.error('Error fetching workspace:', error);
      throw error;
    }
  }

  static async listWorkspaces() {
    try {
      const response = await axiosInstance.get(process.env.REACT_APP_API_URL+'/workspaces');
      return response;
    } catch (error) {
      console.error('Error fetching workspaces:', error);
      throw error;
    }
  }

  // Create a new workspace
  static async saveWorkspace(workspaceData) {
    try {
      const response = await axiosInstance.put(process.env.REACT_APP_API_URL+'/workspace', workspaceData);
      return response;
    } catch (error) {
      console.error('Error creating workspace:', error);
      throw error;
    }
  }

}

export default WorkspaceServices;
